// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDo0IxraYAOJfPyHUKHXC-UsceAJzyl6KQ",
  authDomain: "vitgpa.firebaseapp.com",
  projectId: "vitgpa",
  storageBucket: "vitgpa.firebasestorage.app",
  messagingSenderId: "500429527561",
  appId: "1:500429527561:web:ea48f4da244c2e84cf76d8",
  measurementId: "G-9REJWGF9XZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, analytics, auth, db };
